import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.extension-alert', {
        url: '/extensionalert',
        component: 'publicExtensionAlert',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/extension-alert/extension-alert.state.js